"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowSchemaProperties = exports.WorkflowConfigurationSchema = exports.WorkflowExecutionDetailsSchema = exports.WorkflowStepSchema = exports.WorkflowExecutionSchema = exports.WorkflowStepStatusEnum = exports.WorkflowExecutionStatus = void 0;
const zod_1 = require("zod");
const activity_log_schema_1 = require("./activity-log-schema");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.WorkflowExecutionStatus = zod_1.z.enum([
    "unknown",
    "running",
    "completed",
    "failed",
    "terminated",
    "timed_out",
]);
exports.WorkflowStepStatusEnum = zod_1.z.enum(["success", "failed"]);
exports.WorkflowExecutionSchema = base_schema_1.BaseSchema.extend({
    organizationId: zod_1.z.string(),
    workflowName: zod_1.z.string(),
    workflowDisplayName: zod_1.z.string().optional(),
    executionId: zod_1.z.string(),
    status: exports.WorkflowExecutionStatus,
    result: zod_1.z.object({}).partial().passthrough().optional(),
    startedAt: zod_1.z.string().datetime({ offset: true }),
    completedAt: zod_1.z.string().datetime({ offset: true }).nullish(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
    deletedAt: zod_1.z.string().datetime({ offset: true }).nullish(),
    isDeleted: zod_1.z.boolean().optional(),
});
exports.WorkflowStepSchema = zod_1.z.object({
    id: zod_1.z.string(),
    timestamp: zod_1.z.string().datetime({ offset: true }),
    requestId: zod_1.z.string().optional(),
    action: activity_log_schema_1.ActivityActionEnum,
    actorId: zod_1.z.string(),
    actorType: activity_log_schema_1.ActorTypeEnum,
    resourceId: zod_1.z.string(),
    resourceType: activity_log_schema_1.ResourceTypeEnum,
    organizationId: zod_1.z.string(),
    clientId: zod_1.z.string().optional(),
    data: zod_1.z.object({}).passthrough().optional(),
    status: exports.WorkflowStepStatusEnum.optional(),
});
exports.WorkflowExecutionDetailsSchema = exports.WorkflowExecutionSchema.extend({
    steps: zod_1.z.array(exports.WorkflowStepSchema).optional(),
});
exports.WorkflowConfigurationSchema = zod_1.z.object({
    id: zod_1.z.string(),
    displayName: zod_1.z.string(),
    icon: zod_1.z.string(),
    summary: zod_1.z.string(),
    description: zod_1.z.string(),
    keywords: zod_1.z.array(zod_1.z.string()).optional(),
});
exports.WorkflowSchemaProperties = {
    collectionName: "workflows",
    deleteMode: schema_properties_interface_1.DeleteMode.None,
};
//# sourceMappingURL=workflow-schema.js.map